import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AuthLayoutComponent } from "../layout/auth-layout.component";
import {CommonModule} from "@angular/common";
import { SignInFlowComponent } from '@auth/sign-in-flow/sign-in-flow.component';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports:[ CommonModule, AuthLayoutComponent, SignInFlowComponent ]
})
export class SignInComponent {}
